import React, { useEffect, useState } from 'react';
import { Flex, Select } from '@smarterservices/smarter-ui';
import PhotoUploader from '../PhotoUploader';
import DualPane from '../DualPane';
import StepInstructions from '../Common/StepInstructions';

const IdCheck = ({ stepData, setIsTaskComplete, setStepMetadata }) => {
  const [isShowingOptions, setIsShowingOptions] = useState(false);
  const [renderDropdown, setRenderDropdown] = useState(false);
  const [validIds, setValidIds] = useState([]);
  const [selectedId, setSelectedId] = useState('');

  useEffect(() => {
    setStepMetadata({ idType: null });
    /*
    if (stepData?.validIds && stepData.validIds.length > 0) {
      setValidIds(stepData.validIds);
      const id = stepData.validIds[0];
      setSelectedId(id);
      setStepMetadata({ idType: id });
      setRenderDropdown(true);
    }
    */
  }, [stepData, setStepMetadata]);

  const handleSelectChange = (event, { id }) => {
    setStepMetadata({ idType: id });
    setSelectedId(id);
    setIsShowingOptions(false);
  };

  return (
    <DualPane
      leftPane={
        <StepInstructions instructions={stepData?.body} />
      }
      rightPane={
        <Flex direction="column" width="100%" alignItems="center">
          <Flex direction="column" alignItems="center" width="100%">
            <Flex direction="row" alignItems="center" margin="0 0 medium 0">
              {renderDropdown && (
                <Select
                  renderLabel=""
                  inputValue={selectedId}
                  isShowingOptions={isShowingOptions}
                  onRequestShowOptions={() => setIsShowingOptions(true)}
                  onRequestHideOptions={() => setIsShowingOptions(false)}
                  onRequestSelectOption={handleSelectChange}
                  size="medium"
                >
                  {validIds &&
                    validIds.length > 0 &&
                    validIds.map((id) => (
                      <Select.Option key={id} id={id} value={id}>
                        {id}
                      </Select.Option>
                    ))}
                </Select>
              )}
            </Flex>
            <PhotoUploader
              photoType="idFront"
              setIsTaskComplete={setIsTaskComplete}
              stepData={stepData}
            />
          </Flex>
        </Flex>
      }
    />
  );
};

export default IdCheck;
